


import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"
const TinPlate = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (
    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
        backgroundImage: `url(${ProBg})`,  backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>Tin Plate Coils & Sheet</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
                <p style={{lineHeight:"2.4"}}>
<h3>Introduction to Tin Mill Products</h3>
<p>Mill products include electrolytic tinplate, electrolytic chromium coated steel (also referred to as tin-free steel or TFS), and black plate, the uncoated steel. About 90% of tin mill products made in the world are used by the container industry in the manufacture of cans, ends, and closures for the food and beverage industry. The balance of production is used for automotive components, shelving, computer chassis, telecommunications cable, cookware, etc.</p>

<h3>Historical Background</h3>
<p>Tin-coated vessels are known to have existed as early as 23 A.D., but the tin was apparently only used for decoration. The first tinplate appears to have been made in Bavaria in the fourteenth century, and by the sixteenth century, a thriving tinplate industry existed in Saxony and Bohemia. Tinplate manufacture spread to England in the late seventeenth and early eighteenth centuries.</p>

<h3>Advancements in the Tinplate Industry</h3>
<p>The tinplate industry as we know it today is founded on the invention of the process of preserving sterilized food for long periods of time by Nicolas Appert in 1810. By 1812, Appert was successfully packaging a variety of products in glass containers for a growing market.</p>
<p>The Appert process was adapted to the preservation of food in tinplate containers by John Hall in 1812 in London. By the 1820s, canned foods were widely sold in England and France, and by 1839, foods were being canned in the United States. The American can industry grew explosively as a result of the Civil War, the subsequent settling of the west, and the growth of the oil industry.</p>

<h3>Modern Innovations</h3>
<p>Starting in the 1880s, a series of technical innovations transformed the tinplate industry. These included the replacement of wrought iron with steel for the black plate in about 1880; the development of continuous cold reduction in 1927, that eliminated hot-pack rolling; the introduction of continuous electro-tinning on a small scale in Germany in 1934 and on a commercial scale in the United States in 1937, which replaced the hot dip process; the invention of double cold reduction in 1960; and the invention of TFS in the early 1960s in Japan and the United States.</p>

<h3>Applications</h3>
<p>Tin mill products are also used by the automotive, building, appliance, and furniture industries, all of which take advantage of the unique properties of these light-gauge steel products.</p>

<h3>Electrolytic Coating</h3>
<h3>Electrolytic Tinplating</h3>
<p>Black plate destined for coating goes directly from either the temper mill or double cold reduction mill to the coating line. The sequence of operations that occurs in a tinplating line, at speeds up to 2000 feet per minute, includes:</p>
<ul>
  <li>Charging the Coil</li>
  <li>Side Trimming</li>
  <li>Clean & Pickle</li>
  <li>Electroplating</li>
  <li>Melting Tower</li>
  <li>Chemical Treatment</li>
  <li>Oiling</li>
  <li>Recoiling</li>
  <li>Quality Inspection</li>
</ul>

<h3>Electrolytic Chromium Coated Sheet</h3>
<p>Chromium and chromium oxide coatings, developed for food packaging in the 1960s, offer superior lacquer adhesion and good storage properties. These coatings are mixtures of chromium metal and chromium oxides.</p>

<h3>Product Characteristics</h3>
<p>Tin mill products are produced with certain standardized product characteristics, including terminology, composition, mechanical properties, surface finish, coating weights, and the like. These characteristics are covered in detail in the ASTM Standard Specifications.</p>

<h3>Classification of Tin Mill Products</h3>
<p>The steel industry has adopted standard product names, nomenclature, and order sequencing as published by ASTM, including classifications for black plate, electrolytic tin coated products, and electrolytic chromium coated products.</p>

 </p>
                
              </div>
            </div>
          </div>
                <div className="container my-4">
            <h2 className="text-center mb-4">TEMPERS</h2>
            <div className="table-responsive">
<table className="table table-bordered">
  <thead className="table-dark">
    <tr>
      <th className="text-center">Designation</th>
      <th className="text-center">Rockwell Hardness<br />Aim 30-T*</th>
      <th className="text-center">Approximate Longitudinal<br />Yield Strength, ksi*</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="text-center">T-1 BA<br />T-2 BA<br />T-3 BA<br />T-4 CA<br />T-5 CA<br />DR-8 BA<br />DR-9 CA</td>
      <td className="text-center">49 +/- 4<br />53 +/- 4<br />57 +/- 4<br />61 +/- 4<br />65 +/- 4<br />73 Mean<br />76 Mean</td>
      <td className="text-center">25 – 42<br />34 – 46<br />40 – 52<br />48 – 60<br />57 – 58<br />70 – 85<br />85 – 100</td>
    </tr>
  </tbody>
</table>
<br />

<br />

<br />
 <h2 className="text-center mb-4">FINISHES</h2>
<table className="table table-bordered">
  <thead className="table-dark">
    <tr>
      <th className="text-center">Designation</th>
      <th className="text-center">Approximate A-A*<br />Microinch Range</th>
      <th className="text-center">Characteristic</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="text-center">5C</td>
      <td className="text-center">30 – 60</td>
      <td className="text-center">Standard blasted surface for black plate and some tinplate and TFS requirements. For tinplate, when the tin is unmelted, and when the 5C finish is used for black plate and TFS, the finish is often referred to as “matte” finish. On tinplate only, when the tin is melted, the finish is sometimes referred to as “silver” or “SBF”, or “brite grit”.</td>
    </tr>
    <tr>
      <td className="text-center">7A</td>
      <td className="text-center">5 or less</td>
      <td className="text-center">A lustrous, smooth surface typically found only on black plate intended for electroplating. It is currently not available in the U.S.</td>
    </tr>
    <tr>
      <td className="text-center">7B</td>
      <td className="text-center">7 – 15</td>
      <td className="text-center">A smooth finish that may contain fine grit lines. Usually used only for tinplate that is melted after plating and then it’s often referred to as “bright” finish because the surface is very smooth and reflective. Limited availability, only made by a few mills.</td>
    </tr>
    <tr>
      <td className="text-center">7C</td>
      <td className="text-center">12 – 22</td>
      <td className="text-center">A smooth finish with grit lines. This is the most common finish for tin mill products, especially tinplate and TFS though black plate can be ordered with this finish. When used for tinplate that is melted after plating, or for black plate or TFS, the finish is commonly referred to as “stone” finish.</td>
    </tr>
  </tbody>
</table>

<br />
<br />
 <table className="table table-bordered">
                <thead className="table-dark">
                    <tr>
                        <th className="text-center">Base Weight</th>
                        <th className="text-center">Thickness in/mm</th>
                        <th className="text-center">Base Weight</th>
                        <th className="text-center">Thickness in/mm</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="text-center">53<br />55<br />57<br />60<br />63<br />65<br />68<br />70<br />73<br />75<br />78<br />80<br />83<br />85</td>
                        <td className="text-center">0.0058 / 0.15<br />0.0061 / 0.155<br />0.0063 / 0.16<br />0.0066 / 0.17<br />0.0069 / 0.175<br />0.0072 / 0.18<br />0.0075 / 0.19<br />0.0077 / 0.195<br />0.0080 / 0.20<br />0.0083 / 0.21<br />0.0086 / 0.22<br />0.0088 / 0.22<br />0.0091 / 0.23<br />0.0094 / 0.24</td>
                        <td className="text-center">90<br />93<br />95<br />98<br />100<br />103<br />105<br />107<br />112<br />115<br />118<br />123<br />128<br />135</td>
                        <td className="text-center">0.0099 / 0.25<br />0.0102 / 0.26<br />0.0105 / 0.27<br />0.0108 / 0.275<br />0.0110 / 0.28<br />0.0113 / 0.29<br />0.0116 / 0.295<br />0.0118 / 0.30<br />0.0123 / 0.31<br />0.0127 / 0.32<br />0.0130 / 0.33<br />0.0135 / 0.34<br />0.0141 / 0.36<br />0.0149 / 0.38</td>
                    </tr>
                    <tr>
                        <td colSpan="4" className="text-center">
                            <small>For base weights not included in the table, the decimal thickness can be calculated by multiplying the base weight by 0.00011.</small>
                        </td>
                    </tr>
                </tbody>
            </table>
<br />
<br />
<br />


 <h2 className="text-center mb-4">TIN COATINGS – STANDARD COATING WEIGHTS</h2>

 <table className="table table-bordered">
      <thead className="table-dark">
        <tr>
          <th className="text-center">
            <strong>Coating Weight<br />Designation (US) [EURO]</strong>
          </th>
          <th className="text-center">
            <strong>Nominal Tin Coating Weight<br />Each Surface, Lb./Base Box (US) [EURO]</strong>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="text-center">
            (05) [0.55/0.55]<br />
            (10) [1.1/1.1]<br />
            (20/05) [2.2/0.55]<br />
            (15) [1.7/1.7]<br />
            (20/10) [2.2/1.1]<br />
            (20) [2.2/2.2]<br />
            (25/20) [2.8/2.2]<br />
            (25) [2.8/2.8]<br />
            (50/20) [5.6/2.2]<br />
            (50/25) [5.6/2.8]<br />
            (75/20) [8.4/2.2]<br />
            (50) [5.6/5.6]<br />
            (75) [8.4/8.4]<br />
            (100) [11.2/11.2]<br />
            (75/25) [8.4/2.8]<br />
            (100/20) [11.2/2.2]<br />
            (100/25) [11.2/2.8]
          </td>
          <td className="text-center">
            (0.025/0.025) [0.55/0.55]<br />
            (0.05/0.05) [1.1/1.1]<br />
            (0.10/0.025) [2.2/0.55]<br />
            (0.075/0.075) [1.7/1.7]<br />
            (0.10/0.05) [2.2/1.1]<br />
            (0.10/0.10) [2.2/2.2]<br />
            (0.125/0.10) [2.8/2.2]<br />
            (0.125/0.125) [2.8/2.8]<br />
            (0.25/0.10) [5.6/2.2]<br />
            (0.25/0.125) [5.6/2.8]<br />
            (0.375/0.10) [8.4/2.2]<br />
            (0.25/0.25) [5.6/5.6]<br />
            (0.375/0.375) [8.4/8.4]<br />
            (0.50/0.50) [11.2/11.2]<br />
            (0.375/0.125) [8.4/2.8]<br />
            (0.50/0.10) [11.2/2.2]<br />
            (0.50/0.125) [11.2/2.8]
          </td>
        </tr>
        <tr>
          <td colSpan="2" className="text-center">
            One pound of tin per base box (shared over both surfaces) is equivalent to approximately 0.000060 inch thickness on each surface.
            <br />
            This list represents standard coating weights. Others available upon inquiry.
          </td>
        </tr>
      </tbody>
    </table>
            </div>
        </div>
        </div>
      </section>
    </div>
  );
}

export default TinPlate;
